import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import "./modal.css";
import {
	useGetAssignmentMarkByStudentIdAndAssignmentIdQuery,
	useSubmitAssignmentMutation,
} from "../../../features/assignmentMark/assignmentMarkApi";
import MessageToast from "../../ui/MessageToast";

export default function AssignmentModal({ isOpen, onClose, assignment }) {
	const { id: userId, name } = useSelector((state) => state.auth.user);
	const {
		id: assignmentId,
		title,
		video_title,
		totalMark,
	} = assignment || {};

	const [repoLink, setRepoLink] = useState("");
	const [
		submitAssignment,
		{
			isSuccess: isAssignmentSubmitSuccess,
			isError: isAssignmentSubmitError,
		},
	] = useSubmitAssignmentMutation() || {};

	const params = { studentId: userId, assignmentId };
	const {
		data: alreadySubmittedAssignments,
		isSuccess: previousSubmissionChecked,
	} =
		useGetAssignmentMarkByStudentIdAndAssignmentIdQuery(params, {
			refetchOnMountOrArgChange: true,
		}) || {};

	let alreadySubmitted = false;
	if (previousSubmissionChecked && alreadySubmittedAssignments?.length > 0) {
		alreadySubmitted = true;
	}

	useEffect(() => {
		console.log("AM: fgg");
		if (isAssignmentSubmitSuccess) {
			onClose(false);
		}
	}, [isAssignmentSubmitError, isAssignmentSubmitSuccess, onClose]);

	const handleAssignmentSubmit = (e) => {
		e.preventDefault();

		let assignmentData = {
			student_id: userId,
			student_name: name,
			assignment_id: assignmentId,
			title: title,
			createdAt: new Date().toISOString(),
			totalMark: totalMark,
			mark: 0,
			repo_link: repoLink,
			status: "pending",
		};

		submitAssignment(assignmentData);
	};

	return (
		isOpen &&
		previousSubmissionChecked && (
			<>
				<div className="modal" id="assignment-modal">
					<div className="modal-content">
						<div className="modal-header">
							<div className="flex justify-between">
								<h1 className="modal-title font-bold">
									{video_title}
								</h1>
								{alreadySubmitted && (
									<button className="btn-success px-3 font-bold py-1 rounded-full text-sm">
										Submitted
									</button>
								)}
							</div>
							<div>
								<div className="flex">
									<h3 className="font-bold">Task:</h3>
									<h4 className="ml-5">{title}</h4>
								</div>
								<div className="text-sm font-medium">
									Total mark: {totalMark}
								</div>
								{alreadySubmitted &&
									alreadySubmittedAssignments[0].status ===
										"pending" && (
										<div className="text-sm">
											Evaluation:{" "}
											<span className="text-sm font-medium rounded-md py-1 px-2">
												Pending
											</span>
										</div>
									)}
								{alreadySubmitted &&
									alreadySubmittedAssignments[0].status ===
										"published" && (
										<div className="">
											Obtained mark:{" "}
											<span>
												{
													alreadySubmittedAssignments[0]
														.mark
												}
											</span>
										</div>
									)}
							</div>
						</div>
						<div className="modal-body">
							<form
								onSubmit={handleAssignmentSubmit}
								className="mt-3 space-y-6"
							>
								<div className="rounded-md shadow-sm -space-y-px">
									<div>
										<label
											className="font-bold"
											htmlFor="assignment"
										>
											{alreadySubmitted
												? "Your submitted link"
												: "Repository link"}
										</label>
										<br />
										{!alreadySubmitted ? (
											<input
												value={repoLink}
												onChange={(e) =>
													setRepoLink(e.target.value)
												}
												id="assignment"
												name="assignment"
												type="url"
												autoComplete="false"
												required
												className="login-input rounded-t-md mt-3"
												placeholder="Assignment github repository link"
											/>
										) : (
											<input
												value={
													alreadySubmittedAssignments[0]
														.repo_link
												}
												id="assignment"
												name="assignment"
												type="assignment"
												autoComplete="false"
												required
												className="login-input rounded-t-md mt-3"
												placeholder="Assignment github repository link"
												disabled
											/>
										)}
									</div>
								</div>
								<div style={{ display: "flex" }}>
									{!alreadySubmitted && (
										<button
											type="submit"
											className="group relative flex justify-center py-1 px-4 border border-transparent text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
										>
											Submit
										</button>
									)}
									<button
										type="button"
										onClick={() => onClose(false)}
										className="ml-5 group relative flex justify-center py-1 px-4 border text-sm font-medium rounded-md text-white bg-violet-600 hover:bg-violet-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-violet-500"
									>
										Close
									</button>
								</div>
							</form>
						</div>
					</div>

					{isAssignmentSubmitSuccess && (
						<MessageToast
							message="Assignment submitted"
							delay={3000}
						/>
					)}
					{isAssignmentSubmitError && (
						<MessageToast
							message="There was an error submitting the assignment"
							type="error"
							delay={3000}
						/>
					)}
				</div>
			</>
		)
	);
}
